import { GameSpeedTier } from '../types'

// Base rate at which stoke is gained while offline (per hour)
export const BASE_OFFLINE_STOKE_GAIN_PER_HOUR = 10
export const STOKE_SPEED_LEVELS: Record<number, GameSpeedTier> = {
  0: 1,
  1: 1.5,
  2: 2,
  3: 3,
  5: 7,
  6: 10,
  7: 15,
  8: 20,
  9: 30,
  10: 50
}

// Stoke capacity tiers (in game hours)
export const STOKE_CAP_TIERS = {
  LEVEL_0: 30, // 1 day - starting cap
  LEVEL_1: 80, // 3 days
  LEVEL_2: 180, // 1 week
  LEVEL_3: 750, // 1 month (30 days)
  LEVEL_4: 2400, // 3 months
  LEVEL_5: 9999 // 1 year (365 days)
}

// Base stoke capacity that can be upgraded through quests
export const BASE_STOKE_CAP = STOKE_CAP_TIERS.LEVEL_0

// The cost of stoke per real minute at different game speeds
export const STOKE_GAME_SPEED_COSTS: Record<GameSpeedTier, number> = {
  1: 0, // Normal speed is free
  1.5: 2, // Very minimal cost
  2: 3, // 2x the cost of 1.5x
  3: 4, // Exponential growth begins
  5: 7, // 2x the cost of 4x
  7: 10, // Higher cost jump
  10: 15, // 2x the cost of 10x
  15: 22, // 2x the cost of 25x
  20: 40, // 2x the cost of 50x
  30: 70, // 2x the cost of 100x
  50: 150 // Higher than 2x the cost of 100x
}

// Initially unlocked game speeds
export const INITIAL_UNLOCKED_SPEEDS: GameSpeedTier[] = [1]

// Active stoke catching mini-game rates
export const STOKE_BUBBLE_SIZES = {
  LARGE: {
    amount: 1,
    displayTimeMs: 2000,
    probability: 0.6,
    comboMultiplier: 1
  },
  MEDIUM: {
    amount: 2,
    displayTimeMs: 1300,
    probability: 0.3,
    comboMultiplier: 1.2
  },
  SMALL: {
    amount: 4,
    displayTimeMs: 800,
    probability: 0.1,
    comboMultiplier: 1.5
  }
}

// Time between stoke bubbles appearing (in milliseconds)
export const STOKE_BUBBLE_INTERVAL_MS = 3000

// Maximum stoke combo multiplier
export const MAX_STOKE_COMBO_MULTIPLIER = 3

// Stoke combo decay time (in milliseconds)
export const STOKE_COMBO_DECAY_MS = 5000

// Stoke quest rewards
export const STOKE_QUEST_REWARDS = {
  // Multiplier rewards
  MULTIPLIER_SMALL: 1.5, // 50% increase
  MULTIPLIER_MEDIUM: 2, // 100% increase
  MULTIPLIER_LARGE: 3, // 200% increase
  MULTIPLIER_XLARGE: 4, // 300% increase
  MULTIPLIER_XXLARGE: 8, // 400% increase

  // Cap upgrades - use the tier definitions
  CAP_SMALL: STOKE_CAP_TIERS.LEVEL_1,
  CAP_MEDIUM: STOKE_CAP_TIERS.LEVEL_2,
  CAP_LARGE: STOKE_CAP_TIERS.LEVEL_3,
  CAP_XLARGE: STOKE_CAP_TIERS.LEVEL_4,
  CAP_XXLARGE: STOKE_CAP_TIERS.LEVEL_5
}
